// src/components/RequiredMark.js
export default function RequiredMark({ qa = 'required-mark' }) {
  return (
    <span data-qa={qa} className="text-red-500 ml-0.5" aria-hidden="true">
      *
    </span>
  );
}
